import { styled } from 'styled-components';
import { Text } from '@comicrelief/component-library';
import { useAppSelector } from '@/store/hooks';
import StepSlider from '@/components/stepSlider/StepSlider';
import { formatAmount } from '@/services/journeys/utils';

const StyledSubHeading = styled(Text)`
  margin-top: 1rem;
  && {
    line-height: normal;
  }
`;

const PageHeaderWrapper = styled.div`
  margin-bottom: 1.9rem;
`;

interface PageHeaderProps {
  currentStep: number;
  totalSteps: number;
  headerText: string;
  initialText: string;
  supplementaryText?: string;
  currencySymbol: string;
}

export default function PageHeaderSimplified({
  currentStep,
  totalSteps,
  headerText,
  initialText,
  supplementaryText = '',
  currencySymbol
}: PageHeaderProps) {
  const paymentSelectState = useAppSelector(state => state.paymentSelect);
  const shippingDetailsState = useAppSelector(state => state.shippingDetails);

  // Since postalRewards is only ever set on AARN journeys, we can use it as a flag in this more general context;
  // this addition represets the additional step ('ShippingDetails') for when the user has opted IN to postal rewards:
  const tweakedTotalSteps = shippingDetailsState.postalRewards ? totalSteps + 1 : totalSteps;

  return (
    <PageHeaderWrapper>
      <Text
        tag="h2"
        family="Anton"
        color="black"
        uppercase
        data-test="header-text"
      >
        {headerText}
      </Text>

      <StyledSubHeading
        tag="h4"
        family="Montserrat"
        color="black"
      >
        {initialText}
        {' '}
        {currencySymbol}
        {formatAmount(paymentSelectState.amount)}
        {supplementaryText && ` ${supplementaryText}`}

      </StyledSubHeading>

      <StepSlider
        currentStep={currentStep}
        totalSteps={tweakedTotalSteps}
      />

    </PageHeaderWrapper>
  );
}
